export var types = {
    SET_LOCALE: 'SET_LOCALE',
};
export var setLocale = function (lang, messages) {
    return {
        type: types.SET_LOCALE,
        payload: { lang: lang, messages: messages },
    };
};
//# sourceMappingURL=locale.js.map